import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class OrganizationOwnerPhoneNumberRoute extends Route {
  mainLayout = MainLayout;

  @service phoneInput;
  @service userManager;

  async model() {
    let registration = this.modelFor('registration');

    let organization = registration.get('organization');
    let owner = await registration.get('owner');

    await this.userManager.loadUser();

    return { organization, owner };
  }

  async afterModel() {
    await this.phoneInput.load();
  }
}
